__turbopack_context__.v({
  "black": "index-module-scss-module__EVVq2a__black",
  "grey": "index-module-scss-module__EVVq2a__grey",
  "spin": "index-module-scss-module__EVVq2a__spin",
  "spinner": "index-module-scss-module__EVVq2a__spinner",
  "white": "index-module-scss-module__EVVq2a__white",
});
